import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AppLayout from "./components/AppLayout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import SectionPage from "./pages/SectionPage";
import EntryDetailPage from "./pages/EntryDetailPage";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

function AppContent() {
  return (
    <>
      <ScrollToTop />

      <AppLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />

          <Route path="/:sectionSlug" element={<SectionPage />} />
          <Route path="/:sectionSlug/:slug" element={<EntryDetailPage />} />
        </Routes>
      </AppLayout>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}